import { useState, useEffect } from 'react';

const initialState = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
};

export const useBoundingClientRect = (ref, compare) => {
  const [position, setPosition] = useState(initialState);

  useEffect(() => {
    if (ref.current) {
      setPosition(ref.current.getBoundingClientRect() || initialState);
    }
  }, [ref, compare]);

  return position;
};
